import { cn } from "@/lib/cn"
import { ReactNode } from "react"

type SiteHeaderProps = {
  children: ReactNode
  id?: string
  className?: string
}

const SiteHeader = ({ children, id, className }: SiteHeaderProps) => {
  return (
    <header
      id={id}
      className={cn(
        "bg-site-header text-site-header-text sticky top-0 z-50 h-(--header-height) px-4 shadow-[0_0.125rem_0.625rem_0_rgba(34,34,34,.04)] md:h-(--header-height-md) md:px-8",
        className,
      )}
    >
      <nav className="flex h-full items-center justify-between">{children}</nav>
    </header>
  )
}

export { SiteHeader }
